import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .init({
        // we init with resources
        resources: {
            en: {
                translations: {
                    lang: "en",
                    page: {
                        headTitle: "Create an account",
                        subTitle: "<span>Sell more to your customers</span>with Artifical Intelligence powered sales assistant",
                        error: {
                            header: "Error",
                            text: 'Something went wrong.<br/>Please contact with Edward support by email: <a href="mailto:support@edward.ai">support@edward.ai</a>'
                        }
                    },
                    form: {
                        email: {
                            placeholder: "email",
                            error: "Please provide a valid email address",
                            exist: "This email address is already taken. Please try another."
                        },
                        password: {
                            placeholder: "password",
                            error: "Please provide password"
                        },
                        phoneNumber: {
                            fullNumber: "Full number",
                            countryCode: "Country code",
                            placeholder: "phone number",
                            error: "Please provide phone number",
                            exist: "This phone number is already taken."
                        },
                        terms: {
                            text: `By signing up I agree to the <a href="https://edward.ai/privacy/" target="_blank">terms & conditions</a>`,
                            noCheck: "Please accept the terms & conditions"
                        },
                        backend: {
                            error: {
                                server: "Error occurred during connect to the server",
                                login: "Error occurred during login to the dashboard",
                                createAccount: "Error occurred during creating account"
                            }
                        },
                        signUp: "Sign up",
                    }
                }
            },
            pl: {
                translations: {
                    lang: "pl",
                    page: {
                        headTitle: "Załóż konto",
                        subTitle: "<span>Sprzedawaj więcej</span> z inteligentnym asystentem dedykowanym dla działu sprzedaży",
                        error: {
                            header: "Wystąpił błąd",
                            text: 'Coś poszło nie tak.<br/>Proszę skontaktować się z działem wsparcia Edwarda poprzez email: <a href="mailto:support@edward.ai">support@edward.ai</a>'
                        }
                    },
                    form: {
                        email: {
                            placeholder: "email",
                            error: "Podaj poprawny adres email",
                            exist: "Podany adres email jest już zajęty"
                        },
                        password: {
                            placeholder: "hasło",
                            error: "Proszę wpisać hasło"
                        },
                        phoneNumber: {
                            placeholder: "numer telefonu",
                            fullNumber: "Pełny numer",
                            countryCode: "Kod kraju",
                            error: "Proszę wpisać numer telefonu",
                            exist: "Podany numer telefonu jest już istnieje w systemie"
                        },
                        terms: {
                            text: `Rejestrując się akceptujesz <a href="https://edward.ai/pl/regulamin" target="_blank">regulamin</a>`,
                            noCheck: "Proszę zaakceptować regulamin"
                        },
                        backend: {
                            error: {
                                server: "Wystąpił błąd podczas połączenia z serwerem",
                                login: "Błąd podczas logowania do panelu.",
                                createAccount: "Błąd podczas tworzenia konta."
                            }
                        },
                        signUp: "Zarejestruj się"
                    }
                }
            }
        },
        fallbackLng: 'en',

        // have a common namespace used around the full app
        ns: ['translations'],
        nsSeparator: '|',
        defaultNS: 'translations',

        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ','
        },

        react: {
            wait: true
        }
    });

export default i18n;